import { render, staticRenderFns } from "./Page-Invitations.vue?vue&type=template&id=5b35880d&"
import script from "./Page-Invitations.vue?vue&type=script&lang=js&"
export * from "./Page-Invitations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports